import { render, staticRenderFns } from "./SurveysComp.vue?vue&type=template&id=dd0f9154&scoped=true&"
import script from "./SurveysComp.vue?vue&type=script&lang=js&"
export * from "./SurveysComp.vue?vue&type=script&lang=js&"
import style0 from "./SurveysComp.vue?vue&type=style&index=0&id=dd0f9154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0f9154",
  null
  
)

export default component.exports